import { RcClasses } from '../../../../foundation';
export var RcMenuListClasses = RcClasses([], 'RcMenuList');
